import {$document, $html, APP_NAME} from '../utils/environment';
import AbstractModule from './AbstractModule';

import {Event as CalendarEvent} from './Calendar';

const MODULE_NAME     = 'Calendar';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const Event = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.$el.on(Event.CLICK, (e) => {
            e.preventDefault();
            $document.trigger(CalendarEvent.CHANGE_MONTH);
            return false;
        });
    }


    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
